import { PropsWithChildren, useState } from 'react'
import { ReactComponent as AddIcon } from '@svgs/keyline/add.svg'
import { ReactComponent as MinusIcon } from '@svgs/keyline/minus.svg'
import styles from './styles.module.scss'

type FilterAccordionProps = {
  title: string
  active?: boolean
}

function FilterAccordion({
  title,
  active = true,
  children
}: PropsWithChildren<FilterAccordionProps>) {
  const [isOpen, setIsOpen] = useState(false)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div
      className={`${styles.FilterAccordion} ${
        isOpen && active ? styles.isOpen : ''
      } ${!active ? styles.disabled : ''}`}
    >
      <button
        disabled={!active}
        className={styles.FilterAccordion__button}
        onClick={toggleAccordion}
      >
        <span>
          {title}
          {isOpen ? <MinusIcon /> : <AddIcon />}
        </span>
      </button>
      <div className={styles.FilterAccordion__panel}>
        <div className={styles.FilterAccordion__content}>{children}</div>
      </div>
    </div>
  )
}

export default FilterAccordion
